var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "57DDB6CC-4169-4DFB-98CE-C9C98EEC5005") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,5.77315973e-16 C5.82029825,-2.88657986e-16 8.65973959e-16,5.82029825 0,13 C-8.65973959e-16,20.1797017 5.82029825,26 13,26 C20.1797017,26 26,20.1797017 26,13 C26,9.55218563 24.6303611,6.24558476 22.1923882,3.80761184 C19.7544152,1.36963892 16.4478144,2.88657986e-16 13,5.77315973e-16 Z M13,23.4 C7.2562386,23.4 2.6,18.7437614 2.6,13 C2.6,7.2562386 7.2562386,2.6 13,2.6 C18.7437614,2.6 23.4,7.2562386 23.4,13 C23.4,15.7582515 22.3042889,18.4035322 20.3539105,20.3539105 C18.4035322,22.3042889 15.7582515,23.4 13,23.4 Z M13,5.2 C12.2820298,5.2 11.7,5.78202983 11.7,6.5 L11.7,11.7 L9.1,11.7 C8.38202983,11.7 7.8,12.2820298 7.8,13 C7.8,13.7179702 8.38202983,14.3 9.1,14.3 L13,14.3 C13.7179702,14.3 14.3,13.7179702 14.3,13 L14.3,6.5 C14.3,5.78202983 13.7179702,5.2 13,5.2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile---Submitted",
    transform: "translate(-31.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Alert/Pending-Approval",
    transform: "translate(9.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Clock",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInReview);
export default __webpack_public_path__ + "static/media/in-review.7b19138a4b8afe0c1a2396be8f27146a.svg";
export { ForwardRef as ReactComponent };